import { render } from "./RegisterProject.vue?vue&type=template&id=b24515b2&scoped=true"
import script from "./RegisterProject.js?vue&type=script&lang=js"
export * from "./RegisterProject.js?vue&type=script&lang=js"

import "./RegisterProject.scss?vue&type=style&index=0&id=b24515b2&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b24515b2"]])

export default __exports__